/**
 * snapshotLayouts — version-history snapshot grids → `importLayouts` tuples,
 * with the grid 2.0 stored-document migration applied.
 *
 * A snapshot (`.editor/snapshot.json`) is written by whatever app version made
 * that publish commit, so restoring history can hand us a config written by a
 * 0.8-era client — carrying `preventCollision` and/or `config.breakpoints`.
 * Grid 2.0 REMOVED both, including the silent alias mapping that used to fold
 * `preventCollision` onto `reorder`, so importing such a config unmigrated
 * silently flips the grid's reorder semantics on the restored version.
 * `upgradeSerializedLayout` is pure and reference-identical on already-clean
 * layouts, so applying it unconditionally costs nothing.
 *
 * Kept out of snapshotCodec.ts on purpose: that codec is deliberately
 * dependency-free (no `@fredericrous/grid`) so the git read worker can import
 * its path constant without pulling the engine into the worker bundle.
 */
import {
  upgradeSerializedLayout,
  type GridState,
  type SerializedGridLayout,
} from "@fredericrous/grid";

export function snapshotGridsToLayouts(
  grids: Record<string, GridState>,
): ReadonlyArray<readonly [string, SerializedGridLayout]> {
  return Object.entries(grids).map(([gid, gs]) => {
    // GridState → SerializedGridLayout: config sans id, items as an array.
    const { id: _cfgId, ...config } = gs.config;
    void _cfgId;
    return [
      gid,
      upgradeSerializedLayout({ config, items: Object.values(gs.items) }),
    ] as const;
  });
}
